import React from 'react';
import TopNav from './TopNav';
import { Outlet } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, ToastContainer } from 'react-toastify';
import Authentication from './Authentication';
import Footer from './Footer';
import './style/main.css'

const Main = () => {    
    return (
        <div className="app-container">
            <TopNav/>
            <main className="app-content">
            <Outlet />
            <Authentication />
            <ToastContainer
                position="top-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            </main>
            <Footer/>
        </div>
    );
};

export default Main;